import { useCallback } from 'react';
import { useTranslations } from 'next-intl';

export function useNeoOutOfScopeToast() {
  const tSignalsBulk = useTranslations('signals.bulkActions');

  return useCallback(
    () => ({
      title: tSignalsBulk('neoOutOfTestingScopeTitle'),
      description: tSignalsBulk('neoOutOfTestingScopeDescription'),
    }),
    [tSignalsBulk],
  );
}
